import { gql } from '@apollo/client';

export const getStaticInfoMutation = gql`
    query ($name: String) {
      getStaticInfo(name: $name) {
        name
        image
        content
        title
        isEnable
      }
    }
    `;

export const whyHostQuery = gql`
    {
      getWhyHostPage {
          id
          title
          name
          value
      }
    }
    `;

export const uploadStaticBlockMutation = gql`
    mutation uploadStaticBlock($fileName: String, $filePath: String, $name: String) {
      uploadStaticBlock (fileName:$fileName, filePath: $filePath, name:$name) {
        status
      }
    }
    `;

export const removeStaticImagesMutation = gql`
    mutation removeStaticImages($name: String){
      removeStaticImages(name: $name){
        status
      }
    }
    `;

export const removeWhyHostImagesMutation = gql`
    mutation removeWhyHostImages ($name: String!) {
      removeWhyHostImages (name: $name) {
            status
        }
        }
    `;

export const updateWhyHost = gql`
    mutation (
      $dataList: String
    ) {
        updateWhyHost (
            dataList:$dataList
        ) {
            status
            errorMessage                     
        }
    }`;

export const updateWhyHostPage = `mutation (
    $hostBannerTitle1: String,
    $hostBannerImage1: String,
) {
  updateWhyHostPage (
    hostBannerTitle1: $hostBannerTitle1,
    hostBannerImage1: $hostBannerImage1,
  ) {
      status
  }
}`;

export const updateWhyHost2 = `mutation (
    $hostingBlockTitleHeading: String,
    $hostingBlockTitle1: String,
    $hostingBlockTitle2: String,
    $hostingBlockTitle3: String,
    $hostingBlockContent1: String,
    $hostingBlockContent2: String,
    $hostingBlockContent3: String,
    $hostingBlockImage1: String,
    $hostingBlockImage2: String,
    $hostingBlockImage3: String,
) {
  updateWhyHostPage (
    hostingBlockTitleHeading: $hostingBlockTitleHeading,
    hostingBlockTitle1: $hostingBlockTitle1,
    hostingBlockTitle2: $hostingBlockTitle2,
    hostingBlockTitle3: $hostingBlockTitle3,
    hostingBlockContent1: $hostingBlockContent1,
    hostingBlockContent2: $hostingBlockContent2,
    hostingBlockContent3: $hostingBlockContent3,
    hostingBlockImage1: $hostingBlockImage1,
    hostingBlockImage2: $hostingBlockImage2,
    hostingBlockImage3: $hostingBlockImage3,
  ) {
      status
  }
}`;

export const updateWhyHost3 = `mutation (
    $coverSectionTitle1: String,
    $coverSectionContent1: String,
    $coverSectionImage1: String,
    $coverSectionFeature1: String,
    $coverSectionFeature2: String,
    $coverSectionFeature3: String,
    $coverSectionFeature4: String,
    $coverSectionFeature5: String,
    $coverSectionFeature6: String,
) {
  updateWhyHostPage (
    coverSectionTitle1: $coverSectionTitle1,
    coverSectionContent1: $coverSectionContent1,
    coverSectionImage1: $coverSectionImage1,
    coverSectionFeature1: $coverSectionFeature1,
    coverSectionFeature2: $coverSectionFeature2,
    coverSectionFeature3: $coverSectionFeature3,
    coverSectionFeature4: $coverSectionFeature4,
    coverSectionFeature5: $coverSectionFeature5,
    coverSectionFeature6: $coverSectionFeature6,
  ) {
      status
  }
}`;

export const updateWhyHost4 = `mutation (
    $whyhostBannerHeading: String,
    $whyhostBannerImage: String,
    $paymentTitleHeading: String
) {
  updateWhyHostPage (
    whyhostBannerHeading: $whyhostBannerHeading,
    whyhostBannerImage: $whyhostBannerImage,
    paymentTitleHeading: $paymentTitleHeading
  ) {
      status
  }
}`;

export const updateWhyHost7 = `mutation (
    $faqTitle1: String,
    $faqTitle2: String,
    $faqTitle3: String,
    $faqTitle4: String,
    $faqTitle5: String,
    $faqTitle6: String,
    $faqTitle7: String,
    $faqTitle8: String,
    $faqContent1: String,
    $faqContent2: String,
    $faqContent3: String,
    $faqContent4: String,
    $faqContent5: String,
    $faqContent6: String,
    $faqContent7: String,
    $faqContent8: String
) {
  updateWhyHostPage (
    faqTitle1: $faqTitle1,
    faqTitle2: $faqTitle2,
    faqTitle3: $faqTitle3,
    faqTitle4: $faqTitle4,
    faqTitle5: $faqTitle5,
    faqTitle6: $faqTitle6,
    faqTitle7: $faqTitle7,
    faqTitle8: $faqTitle8,
    faqContent1: $faqContent1,
    faqContent2: $faqContent2,
    faqContent3: $faqContent3,
    faqContent4: $faqContent4,
    faqContent5: $faqContent5,
    faqContent6: $faqContent6,
    faqContent7: $faqContent7,
    faqContent8: $faqContent8
  ) {
      status
  }
}`;

export const updateWhyHost6 = `mutation (
    $quoteSectionTitle1: String,
    $quoteSectionContent1: String,
    $quoteSectionTitle2: String,
    $quoteSectionContent2: String,
    $quoteSectionImage1: String,
    $quoteSectionImage2: String,
    $quoteSectionButton1: String,
    $quoteSectionButton2: String
) {
  updateWhyHostPage (
    quoteSectionTitle1: $quoteSectionTitle1,
    quoteSectionContent1: $quoteSectionContent1,
    quoteSectionTitle2: $quoteSectionTitle2,
    quoteSectionContent2: $quoteSectionContent2,
    quoteSectionImage1: $quoteSectionImage1,
    quoteSectionImage2: $quoteSectionImage2,
    quoteSectionButton1: $quoteSectionButton1,
    quoteSectionButton2: $quoteSectionButton2
  ) {
      status
  }
}`;



